module.exports = "<div class=props-list :class={active:blurry}> <prop v-for=\"(prop, value) in fragment\" v-if=\"prop[0]!=='@'\" :parent.sync=fragment :prop=prop></prop> <prop v-for=\"prop in stub\" :parent.sync=fragment :prop=prop></prop> <prop-add :fragment.sync=fragment></prop-add> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PropsList.vue
 ** module id = 142
 ** module chunks = 0
 **/